import router from '@/router' // vue router won't work through Vue.prototype

let notify = null

const _aim = {

  notify (response, type, title, text) {
    return this._handleResponse(response, this._createNotification(response, type, title, text))
  },

  error (response, type, title, text) {
    const notification = this._createNotification(response, type, title, text)
    console.dir(notification)
    return this._handleResponse(response, notification)
  },

  _handleResponse (response, notification) {
    if (response && response.data && response.data.redirect) {
      // we have a redirect, LFG
      router.push(response.data.redirect)
    }
    return this._sendNotification(notification)
  },

  _sendNotification (notification) {
    if (notification.text) {
      return notify ? notify(notification) : console.log('Notification plugin is not ready', notification)
    } else {
      console.log('Empty notification text, not sending')
    }
  },

  _createNotification (response, type, title, text) {
    const notification = {
      group: 'notices',
      title: title || null,
      text: text || null,
      type: type || 'info'
    }
    if (typeof response === 'object' && typeof response.data === 'object') {
      if (!notification.title && typeof response.data.header === 'string') {
        notification.title = response.data.header
      }

      // check for success messages
      if (response.data.success instanceof Array && response.data.success.length) {
        if (!notification.text) {
          notification.text = this._getMessage(response.data.success)
        }
      } else if (!notification.text && typeof response.data.success === 'string') {
        notification.text = response.data.success // plain text message
      }

      // check for error messages
      if (response.data.error instanceof Array && response.data.error.length) {
        if (!type) {
          notification.type = 'error'
        }
        if (!notification.text) {
          notification.text = this._getMessage(response.data.error)
        }
      } else if (!notification.text && typeof response.data.error === 'string') {
        notification.text = response.data.error
      }
    }
    return notification
  },

  _getMessage (data) {
    let msg = ''
    if (data instanceof Array) {
      data.forEach((m) => {
        msg += m + ' '
      })
    } else {
      msg = data
    }
    return msg
  }
}

const Plugin = {
  install (app) {
    notify = app.config.globalProperties.$notify
    app.config.globalProperties.$aim = _aim
    app.config.globalProperties.aim = _aim
    app.$aim = _aim
    window.$aim = _aim
  }
}

export default Plugin
